import React from 'react';

function Password(props) {
  const title = props.title || "password";
  const color = props.color || "#111111"
  const height = props.height || 24;
  const width = props.width || 24;

	return (
		<svg height={height} width={width} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
	<title>{title}</title>
	<g fill={color}>
		<circle cx="7" cy="22.5" r="1.5"/>
		<circle cx="12" cy="22.5" r="1.5"/>
		<circle cx="17" cy="22.5" r="1.5"/>
		<circle cx="22" cy="22.5" r="1.5"/>
		<circle cx="2" cy="22.5" r="1.5"/>
		<path d="M19,8H17V5A5,5,0,0,0,7,5V8H5A1,1,0,0,0,4,9v9a1,1,0,0,0,1,1H19a1,1,0,0,0,1-1V9A1,1,0,0,0,19,8Zm-7,7a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,12,15Zm3-7H9V5a3,3,0,0,1,6,0Z" fill={color}/>
	</g>
</svg>
	);
};

export default Password;